"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppLoaders = void 0;
var _react = require("react");
var _AppLoadersProvider = require("./AppLoadersProvider");
const useAppLoaders = () => {
  const context = (0, _react.useContext)(_AppLoadersProvider.AppLoadersContext);
  if (!context) {
    throw new Error('useAppLoaders must be used within AppLoadersProvider, check that page or component is wrapped with layout component');
  }
  return context;
};
exports.useAppLoaders = useAppLoaders;
